module.exports = __webpack_public_path__ + "static/media/happy-at-work.1b154172.png";